module.exports = __webpack_public_path__ + "static/img/groundabout2.8a4873a4.webp";